import React from "react";
import { Alert } from "react-bootstrap";
import PropTypes from "prop-types";

const Message = ({ variant, title, ...rest }) => {
  return (
    <Alert variant={variant} {...rest}>
      {title}
    </Alert>
  );
};

Message.propTypes = {
  variant: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Message;
